import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const SOLANA_TOKEN_TICKERS = [Ticker.USDC, Ticker.USDT]

export type SolanaTokenTicker = IterableElement<typeof SOLANA_TOKEN_TICKERS>
